/**
 * @file Wrapper module in AngularJS for routing to voice assistant enrollment page
 * @author Max van Loosbroek
 */

import './VoiceAssistantEnrollment/VoiceAssistantEnrollment.module'
import StoreService from '../../common/redux/store.service'
import voiceAssistantEnrollmentPage from './voiceAssistantEnrollmentPage.component'

export default angular
  .module('components.voiceAssistantEnrollmentPage', ['components.tb.voiceAssistantEnrollmentReact'])
  .component('voiceAssistantEnrollmentPage', voiceAssistantEnrollmentPage)
  .service('StoreService', StoreService)
  .config($stateProvider => {
    $stateProvider.state('voiceAssistantEnrollment', {
      parent: 'app',
      url: '^/voice-assistant-enrollment/',
      component: 'voiceAssistantEnrollmentPage',
      reloadOnSearch: false,
      params: {},
      resolve: {}
    })
  }).name
